import type { SessionHrDataAnalysisResult } from '../../../ai-repair';
import type { SessionAnalysisState } from '../types';

export const mapAnalysisResultToState = (
  result: SessionHrDataAnalysisResult
): Exclude<SessionAnalysisState, { status: 'idle' }> => {
  if (result.status === 'failed') {
    return {
      status: 'failed',
      message: result.message ?? 'Analisi non riuscita.',
    };
  }

  if (result.status === 'clean') {
    return {
      status: 'clean',
      summary: result.summary,
      findings: result.findings,
    };
  }

  return {
    status: 'needs_repair',
    summary: result.summary,
    findings: result.findings,
    duplicateCount: result.duplicateCount ?? 0,
    gapCount: result.gapCount ?? 0,
  };
};

export const getAnalysisServiceErrorMessage = (error: Error): string => {
  const message = error.message;
  if (
    message.includes('API key is not configured') ||
    message.includes('invalid_api_key') ||
    message.includes('Incorrect API key') ||
    message.includes('401') ||
    message.includes('OpenAI') ||
    message.includes('API error')
  ) {
    return 'Servizio esterno non disponibile. Riavvia il dev server dopo aver aggiornato la configurazione.';
  }
  return message;
};
